import { PettyCashDetailPage } from '@/features/petty-cash/pages/PettyCashDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/petty-cash/expense/$id/detail')({
  beforeLoad({ context, params }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.view"] })) {
      throw redirect({ to: "/403" });
    }
    throw redirect({ to: "/admin/petty-cash/$id/detail", params });
  },
  component: () => <PettyCashDetailPage />,
})

